import path from 'ramda/src/path'
import length from 'ramda/src/length'

export default function(mapPane) {
  const count = length(path(['children', 0, 'children', 0, 'children'], mapPane))
  return isNaN(count) ? 0 : count
}


// WEBPACK FOOTER //
// ./src/helpers/map/getImageCount.js